import React from "react";
import ReactSelect, { createFilter, components } from "react-select";

export default function Select({
  noPortal = false,
  loadOptions = () => {},
  containerClass,
  ...props
}) {
  let attrs = {
    menuPortalTarget: document.querySelector("#ReactSelectPortal"),
  };

  return (
    <div className={`react-select-container ${containerClass}`}>
      <ReactSelect
        classNamePrefix="react-select"
        filterOption={createFilter({ ignoreAccents: false })}
        {...props}
        {...(noPortal ? {} : attrs)}
      />
    </div>
  );
}

export const selectComponents = components;
